export const caseAssetPath = (path, caseId = 'photo-editor-ui') => `${window.location.origin}/photoeditor_assets/cases/${caseId}${path}`;
